import { Box, CircularProgress, Fab } from '@mui/material';
import { useEffect, useState } from 'react';
import { Check, Save } from '@mui/icons-material';
import { green } from '@mui/material/colors';
import { useUpdateOrderMutation } from '../../features/fullApi';

const OrderActions = ({ params, rowId, setRowId }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const user = JSON.parse(localStorage.getItem('user'))

  console.log("ROWID###", rowId)

  const [updateOrder] = useUpdateOrderMutation()

  const handleSubmit = async () => {
    console.log("handle submit called", params)
    setLoading(true);
    updateOrder({_id: rowId, status: params.row.status}, {id: rowId},{ 
        headers: {
          'Token': `Bearer ${user?.accessToken}`
        }
      })
      .then(res => {
        console.log("Res is", res);
        setSuccess(true);
        setRowId(null);   
        setLoading(false);
      })
      .catch((e) => {
        console.log("e is", e)
      })
  }

  useEffect(() => {
    if (rowId === params.id && success) setSuccess(false);
  }, [rowId]);

  return (
    <Box
      sx={{
        m: 1,
        position: 'relative',
      }}
    >
      {success ? (
        <Fab
          color="primary"
          sx={{
            width: 40,
            height: 40,
            bgcolor: green[500],
            '&:hover': { bgcolor: green[700] },
          }}
        >
          <Check />
        </Fab>
      ) : (
        <Fab
          color="primary"
          sx={{
            width: 40,
            height: 40,
          }}
          disabled={params.id !== rowId || loading}
          onClick={handleSubmit}
        >
          <Save />
        </Fab>
      )}
      {loading && (
        <CircularProgress
          size={52}
          sx={{
            color: green[500],
            position: 'absolute',
            top: -6,
            left: -6,
            zIndex: 1,
          }}
        />
      )}
    </Box>
  );
};

export default OrderActions